/**
 * Generate Order ID Use Case
 * 주문번호 생성 유스케이스
 */

import type { PaymentRepository } from '../../repositories/PaymentRepository';

/**
 * 주문번호 생성 유스케이스
 */
export class GenerateOrderIdUseCase {
  constructor(private readonly paymentRepository: PaymentRepository) {}

  /**
   * 주문번호 생성 실행
   * @param productId 상품 ID
   * @returns 생성된 주문번호
   */
  async execute(productId: string): Promise<string> {
    return this.paymentRepository.generateOrderId(productId);
  }
}
